import React from 'react'
import Avatar from 'components/Avatar'
import { userThumbType } from 'common/types'

import StyledUserThumbHorizontal from './StyledUserThumbHorizontal'

const UserThumbHorizontal = ({ user, inverted }) => (
  <StyledUserThumbHorizontal inverted={+inverted} to={user.nickname ? `/members/${user.nickname}` : ''}>
    <Avatar size="thumbnail" user={user} />
    <div className="user-info">
      <p className="username">{user.screenName || ''}</p>
      <p className="location city">{(user.location || user.locationInfo)?.city.name || ''}</p>
      <p className="location country">{(user.location || user.locationInfo)?.country.name || ''}</p>
    </div>
  </StyledUserThumbHorizontal>
)

UserThumbHorizontal.defaultProps = {
  inverted: false,
  user: {},
}

UserThumbHorizontal.propTypes = userThumbType

export default UserThumbHorizontal
